import { IIndustry } from 'domain/entities/Industry/Industry';
import { CloseCompanyInfo } from 'ui/components/screens/modals/CloseCompanyInfo/CloseCompanyInfo';
import { PublicCompanyDetail } from 'ui/components/common/patterns/PublicCompanyDetail/PublicCompanyDetail';
import { useModal } from 'ui/components/screens/modals/useModal';
import styled from '@emotion/styled';
import Pencil from 'ui/images/icons/pencil.svg';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    text-align: left;
    background-color: #f8f9fd;
`;

const EditButton = styled.button`
    background-color: var(--main-color-blue);
    color: var(--white);
    border: none;
    border-radius: 25px;
    padding: 10px 20px;
    width: fit-content;
    cursor: pointer;
    font-size: var(--font-large);
    font-weight: var(--font-bold);
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    gap: 5px;
    &:hover {
        opacity: 0.9;
    }
    &:active {
        transform: scale(0.98);
    }

    img {
        width: 15px;
    }
`;

const ClosedButton = styled.button`
    color: var(--warn);
    margin-left: 10px;
    background-color: var(--white);
    border: none;
    border-radius: 25px;
    padding: 8px 18px;
    width: fit-content;
    cursor: pointer;
    border: 3px solid var(--warn);
    font-size: var(--font-large);
    font-weight: var(--font-bold);
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    gap: 5px;
    &:hover {
        background-color: var(--warn);
        color: var(--white);
    }
    &:active {
        transform: scale(0.98);
    }
    transition: background-color 0.3s ease, color 0.3s ease;
`;

const SubtitleContainer = styled.div`
    display: flex;
    gap: 10px;
    align-items: center;
    padding: 20px 10px 0 10px;
`;

export const Preview: React.FC<{
    company: any;
    editing: boolean;
    setEditing?: (editing: boolean) => void;
    areaChoices: string[][];
    prefectureChoices: string[][];
    employeeChoices: string[][];
    revenueChoices: string[][];
    profitLevelChoices: string[][];
    netAssetsLevelChoices: string[][];
    industryChoices: IIndustry[];
    unPublish?: () => void;
    reOpen?: () => void;
    loading: boolean;
    isPublish: boolean;
}> = ({
    company,
    editing,
    setEditing,
    areaChoices,
    prefectureChoices,
    employeeChoices,
    revenueChoices,
    profitLevelChoices,
    netAssetsLevelChoices,
    industryChoices,
    unPublish = () => {},
    reOpen = () => {},
    loading,
    isPublish,
}) => {
    const unPublishModal = useModal();
    const {
        openModal: openUnPublishModal,
        createModal: createUnPublishModal,
        closeModal: closeUnPublishModal,
    } = unPublishModal;

    return (
        <Wrapper>
            {createUnPublishModal(
                <CloseCompanyInfo onSubmit={unPublish} onCancel={closeUnPublishModal} loading={loading} />,
            )}

            {!editing && setEditing && (
                <SubtitleContainer>
                    <EditButton onClick={() => setEditing(true)}>
                        <img src={Pencil} alt="Edit" />
                        修正する
                    </EditButton>
                    {isPublish
                        ? openUnPublishModal && (
                              <ClosedButton onClick={openUnPublishModal}>案件の公開を停止する</ClosedButton>
                          )
                        : reOpen && <ClosedButton onClick={reOpen}>案件の公開を再開する</ClosedButton>}
                </SubtitleContainer>
            )}

            <PublicCompanyDetail
                company={company}
                areaChoices={areaChoices}
                prefectureChoices={prefectureChoices}
                employeeChoices={employeeChoices}
                revenueChoices={revenueChoices}
                profitLevelChoices={profitLevelChoices}
                netAssetsLevelChoices={netAssetsLevelChoices}
                industryChoices={industryChoices}
                isPreview
            />
        </Wrapper>
    );
};
